import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, throwError } from 'rxjs';
import { environment } from '../../src/environments/environment';
import { ACCESS_PATH, accessProblem, PlatformAccessService } from './platform-access.service';

export const platformAccessInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const access = inject(PlatformAccessService);
  const base = new URL(environment.apiUrl, window.location.origin);
  const url = new URL(req.url, window.location.origin);
  const prefix = base.pathname.replace(/\/$/, '') + '/admin/';
  if (url.origin !== base.origin || !url.pathname.startsWith(prefix)
    || url.pathname.startsWith(prefix + 'platform-')) return next(req);
  return next(req).pipe(catchError(error => {
    const problem = accessProblem(error.status, error.error);
    if (!problem || !router.url.startsWith('/admin')) return throwError(() => error);
    // Upload dialogs explain storage quotas locally; subscription-wide blocks still redirect.
    const uploadRequest = req.method === 'POST' && (url.pathname === prefix + 'assets' || url.pathname.startsWith(prefix + 'uploads/'));
    if (uploadRequest && problem.code === 'quota_exceeded' && problem.feature === 'storage.bytes') return throwError(() => error);
    access.capture(problem, router.url);
    if (!router.url.startsWith(ACCESS_PATH)) void router.navigateByUrl(ACCESS_PATH);
    // The full-page state replaces the local toast. Never replay a failed mutation.
    return EMPTY;
  }));
};
